import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_FETCH_SC_IN_ACTION_ORDER_DATA_BEGIN,
  REPORTS_FETCH_SC_IN_ACTION_ORDER_DATA_SUCCESS,
  REPORTS_FETCH_SC_IN_ACTION_ORDER_DATA_FAILURE,
  REPORTS_FETCH_SC_IN_ACTION_ORDER_DATA_DISMISS_ERROR,
} from './constants';

export function fetchScInActionOrderData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_FETCH_SC_IN_ACTION_ORDER_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/getScInActionOrderReport`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_FETCH_SC_IN_ACTION_ORDER_DATA_SUCCESS,
            data: {
              data: res.data.data,
              totals: res.data.totals,
              orderSummary: res.data && res.data.summary
            },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_FETCH_SC_IN_ACTION_ORDER_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchScInActionOrderDataError() {
  return {
    type: REPORTS_FETCH_SC_IN_ACTION_ORDER_DATA_DISMISS_ERROR,
  };
}

export function useFetchScInActionOrderData() {
  const dispatch = useDispatch();

  const { reportsOrderData, reportsOrderTotals, orderSummary, fetchScInActionOrderDataPending, fetchScInActionOrderDataError } = useSelector(
    state => ({
      reportsOrderData: state.reports.reportsOrderData,
      reportsOrderTotals: state.reports.reportsOrderTotals,
      orderSummary: state.reports.orderSummary,
      fetchScInActionOrderDataPending: state.reports.fetchScInActionOrderDataPending,
      fetchScInActionOrderDataError: state.reports.fetchScInActionOrderDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchScInActionOrderData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchScInActionOrderDataError());
  }, [dispatch]);

  return {
    reportsOrderData,
    reportsOrderTotals,
    orderSummary,
    fetchScInActionOrderData: boundAction,
    fetchScInActionOrderDataPending,
    fetchScInActionOrderDataError,
    dismissFetchScInActionOrderDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_FETCH_SC_IN_ACTION_ORDER_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchScInActionOrderDataPending: true,
        fetchScInActionOrderDataError: null,
      };

    case REPORTS_FETCH_SC_IN_ACTION_ORDER_DATA_SUCCESS:
      // The request is success
      return {
        ...state,
        reportsOrderData: action.data.data,
        reportsOrderTotals: action.data.totals,
        orderSummary: action.data.orderSummary,
        fetchScInActionOrderDataPending: false,
        fetchScInActionOrderDataError: null,
      };

    case REPORTS_FETCH_SC_IN_ACTION_ORDER_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchScInActionOrderDataPending: false,
        fetchScInActionOrderDataError: action.data.error,
      };

    case REPORTS_FETCH_SC_IN_ACTION_ORDER_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchScInActionOrderDataError: null,
      };

    default:
      return state;
  }
}
